(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["simplewifi-solutions-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-distance-tool]').forEach((tool) => {
    const tabs = Array.from(tool.querySelectorAll('[data-distance-tab]'));
    const panels = Array.from(tool.querySelectorAll('[data-distance-panel]'));

    const activate = (tab) => {
      const target = tab.dataset.distanceTab;
      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.distancePanel !== target;
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        tabs[nextIndex].focus();
        activate(tabs[nextIndex]);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simplewifi-system-questionnaire"] && !Shopify.designMode) return;
  try {
    
  const initSimpleWiFiQuestionnaire = (root) => {
    if (root.dataset.swfqInitialized === 'true') return;
    const form = root.querySelector('form');
    const steps = Array.from(root.querySelectorAll('[data-swfq-step]'));
    if (!form || steps.length === 0) return;

    root.dataset.swfqInitialized = 'true';
    root.classList.add('is-enhanced');
    form.noValidate = true;
    const labels = ['Your locations', 'Distance and visibility', 'Your needs', 'Contact details'];
    const progressLabel = root.querySelector('[data-swfq-progress-label]');
    const progressBar = root.querySelector('[data-swfq-progress-bar]');
    const progressItems = Array.from(root.querySelectorAll('[data-swfq-progress-item]'));
    let currentStep = root.querySelector('[data-swfq-error]') ? steps.length - 1 : 0;

    const showStep = (index, moveFocus = true) => {
      currentStep = index;
      steps.forEach((step, stepIndex) => { step.hidden = stepIndex !== index; });
      progressLabel.textContent = `Step ${index + 1} of ${steps.length}: ${labels[index]}`;
      progressBar.setAttribute('aria-valuenow', String(index + 1));
      progressBar.querySelector('span').style.width = `${((index + 1) / steps.length) * 100}%`;
      progressItems.forEach((item, itemIndex) => {
        item.classList.toggle('is-current', itemIndex === index);
        item.classList.toggle('is-complete', itemIndex < index);
      });
      if (moveFocus) {
        steps[index].querySelector('legend').setAttribute('tabindex', '-1');
        steps[index].querySelector('legend').focus();
      }
    };

    const validateStep = (step) => {
      for (const field of step.querySelectorAll('input, select, textarea')) {
        if (!field.checkValidity()) {
          field.reportValidity();
          field.focus();
          return false;
        }
      }
      return true;
    };

    steps.forEach((step, index) => {
      step.querySelector('[data-swfq-next]')?.addEventListener('click', () => {
        if (validateStep(step)) showStep(index + 1);
      });
      step.querySelector('[data-swfq-back]')?.addEventListener('click', () => showStep(index - 1));
    });

    form.addEventListener('submit', (event) => {
      for (let index = 0; index < steps.length; index += 1) {
        const invalidField = Array.from(steps[index].querySelectorAll('input, select, textarea')).find((field) => !field.checkValidity());
        if (invalidField) {
          event.preventDefault();
          showStep(index);
          invalidField.reportValidity();
          invalidField.focus();
          return;
        }
      }
    });

    showStep(currentStep, false);
  };

  document.querySelectorAll('[data-swfq]').forEach(initSimpleWiFiQuestionnaire);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-swfq]').forEach(initSimpleWiFiQuestionnaire);
  });

  } catch(e) { console.error(e); }
})();
})();
